/* unplugin-vue-components disabled */import { render } from "./winActiveMenu.vue?vue&type=template&id=e908cf26"
import script from "./winActiveMenu.vue?vue&type=script&lang=js"
export * from "./winActiveMenu.vue?vue&type=script&lang=js"

import "./winActiveMenu.vue?vue&type=style&index=0&id=e908cf26&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__